import { createI18n } from 'vue-i18n'
import { translations } from '../i18n';

const i18n = createI18n({
  legacy: false,
  locale: initialLocale(),
  fallbackLocale: 'ptBR',
  messages: translations
})

export default i18n

function initialLocale ()  {
  const browserLang = navigator.language.toLowerCase() || 'pt-br'
  const mapBrowserToApp = {
    pt: 'ptPT',
    en: 'enUS',
    es: 'esES',
    fr: 'frFR',
  }

  if (browserLang === 'pt-br') {
    return 'ptBR'
  }

  const codigoGenerico = browserLang.slice(0, 2)
  return mapBrowserToApp[codigoGenerico] || 'ptBR'
}
